import { FormAggregatedResultEmployeeNPSElement } from "@/components/form-result/aggregated-result/components/FormAggregatedResultEmployeeNPSElement.tsx";
import { FormAggregatedResultGoalElement } from "@/components/form-result/aggregated-result/components/FormAggregatedResultGoalElement.tsx";
import { FormAggregatedResultOpenAnswerElement } from "@/components/form-result/aggregated-result/components/FormAggregatedResultOpenAnswerElement.tsx";
import { FormAggregatedResultScaleElement } from "@/components/form-result/aggregated-result/components/FormAggregatedResultScaleElement.tsx";
import { FormAggregatedResultSelectElement } from "@/components/form-result/aggregated-result/components/FormAggregatedResultSelectElement.tsx";
import { FormAggregatedResultTextElement } from "@/components/form-result/aggregated-result/components/FormAggregatedResultTextElement.tsx";
import { FormAggregatedResultWriteToFieldElement } from "@/components/form-result/aggregated-result/components/FormAggregatedResultWriteToFieldElement.tsx";
import { FormAggregatedResultFileElement } from "@/components/form-result/aggregated-result/components/FormAggregatedResultFileElement.tsx";
import { FormAggregatedResultFilterOptions } from "@/components/form-result/aggregated-result/components/types.ts";
import { ApiFormAggregationResult } from "@/types/forms/form-result.types.ts";
import { ApiFormViewElement } from "@/types/forms/form-view.types.ts";

import { ApiFormElementType } from "@/types/forms/form.types.ts";
import { Stack } from "@skailer-com/uikit";

export interface Props {
  element: ApiFormViewElement;
  results: ApiFormAggregationResult;
  showDetailModalCallback?: (
    element: ApiFormViewElement,
    filterOptions?: FormAggregatedResultFilterOptions
  ) => void;
  hideAISummary?: boolean;
  showMore?: boolean;
}

export const FormAggregatedResultElement = ({
  element,
  results,
  showDetailModalCallback,
  hideAISummary,
  showMore,
}: Props) => {
  const getElement = () => {
    const result = results.elements.find((x) => x.form_element_id === element.id);

    switch (element.type) {
      case ApiFormElementType.text:
        return <FormAggregatedResultTextElement element={element} />;

      case ApiFormElementType.open_answer: {
        return (
          <FormAggregatedResultOpenAnswerElement
            element={element}
            result={result}
            showDetailModalCallback={showDetailModalCallback}
            hideAISummary={hideAISummary}
            showMore={showMore}
          />
        );
      }

      case ApiFormElementType.scale: {
        return (
          <FormAggregatedResultScaleElement
            element={element}
            result={result}
            showDetailModalCallback={showDetailModalCallback}
          />
        );
      }

      case ApiFormElementType.goals: {
        return (
          <FormAggregatedResultGoalElement
            element={element}
            result={result}
            showDetailModalCallback={showDetailModalCallback}
          />
        );
      }

      case ApiFormElementType.select: {
        return (
          <FormAggregatedResultSelectElement
            element={element}
            result={result}
            showDetailModalCallback={showDetailModalCallback}
          />
        );
      }

      case ApiFormElementType.employee_nps: {
        return (
          <FormAggregatedResultEmployeeNPSElement
            element={element}
            result={result}
            showDetailModalCallback={showDetailModalCallback}
          />
        );
      }

      case ApiFormElementType.file: {
        return (
          <FormAggregatedResultFileElement
            element={element}
            result={result}
            showDetailModalCallback={showDetailModalCallback}
          />
        );
      }

      case ApiFormElementType.write_to_field: {
        return <FormAggregatedResultWriteToFieldElement element={element} result={result} />;
      }

      default:
        return null;
    }
  };

  return <Stack>{getElement()}</Stack>;
};
